<template>
  <div class="login h100">
    <vue-headful :title="$PRJ_NAME" />
    <!-- <fish-loader class="loadLogin" :active="isEmitLogin"></fish-loader> -->
    <fish-row style="height:33%;">
      <fish-col span="24"></fish-col>
    </fish-row>
    <fish-row style="height:33%;">
      <fish-col span="8"></fish-col>
      <fish-col span="8">
        <fish-form style="width: 100%;" ref="frmLogin">
          <fish-field name="username" :rules="[{ required: true, message: 'Vui lòng nhập tên tài khoản' }]">
            <fish-input hint="Tài khoản" ref="inputUser" autofocus v-model="username" iconLeft
              icon="fa fa-user"></fish-input>
          </fish-field>
          <fish-field name="password" :rules="[{ required: true, message: 'Vui lòng nhập mật khẩu' }]">
            <fish-input hint="Mật khẩu" ref="inputPass" @keyup.enter="callEvent" v-model="password" type="password"
              iconLeft icon="fa fa-lock"></fish-input>
          </fish-field>
          <fish-button style="width:100%" @click="Login()" type="primary">Đăng nhập</fish-button>
        </fish-form>
      </fish-col>
      <fish-col span="8"></fish-col>
    </fish-row>
    <fish-row style="height:33%;">
      <fish-col span="24"></fish-col>
    </fish-row>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
import { mapMutations } from "vuex";
import md5 from "md5";
export default {
  computed: {
    ...mapState(["oUser"]),
    oUser: {
      get() {
        return this.oUser;
      },
      set(newoUser) {
        this.Set_oUser({ oUser: newoUser });
      },
    },
  },
  mounted() {
    this.$refs.inputUser.$el.children[1].addEventListener(
      "keyup",
      this.inputSubmit
    );
    this.$refs.inputPass.$el.children[1].addEventListener(
      "keyup",
      this.inputSubmit
    );
  },
  data() {
    return {
      isEmitLogin: false,
      username: "",
      password: "",
    };
  },
  methods: {
    ...mapMutations(["Set_oUser", "Set_isLogin"]),
    ...mapActions(["API_Login", "Go_Route"]),
    inputSubmit(e) {
      if (e.key == "Enter") this.Login();
    },
    async Login() {
      // console.log(this.$refs.frmLogin);
      let fValid = null;
      this.$refs.frmLogin.validate((valid) => {
        fValid = valid;
      });
      if (fValid) {
        if (this.username == "" || this.password == "") {
          this.$message.error("Vui lòng nhập đầy đủ thông tin", 2000);
        } else {
          let oUserInfo = {
            username: this.username,
            password: md5(this.password),
          };
          this.isEmitLogin = true;
          let Response = await this.API_Login(oUserInfo);
          this.isEmitLogin = false;
          // console.log(Response);
          if (Response == null) {
            this.Set_isLogin(false);
            this.$message.error(
              "Dữ liệu không chính xác, vui lòng báo Admin",
              3000
            );
          } else if (Response.State == 0) {
            this.Set_isLogin(false);
            // console.log(this);
            this.$message.error(Response.Message, 3000);
          } else if (Response.State == 1) {
            this.oUser = Response.Data.User;
            this.Set_isLogin(true);
            this.Go_Route("/");
          }
        }
      }
    },
  },
};
</script>
<style>
body {
  height: 100% !important;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, Arial, sans-serif;

  min-height: 100% !important;
  width: 100%;
  overflow: hidden;
}

.login {
  position: relative;
  width: 80%;
  max-width: 100%;
  padding: 160px 35px 0;
  margin: 0 auto;
  overflow: hidden;
}

.fish.input {
  padding-bottom: 10px !important;
}

.fish.input>i {
  top: -5px !important;
}

.fish.layout {
  height: 100% !important;
}
</style>
